import TopLayoutBlog from 'docs/src/modules/components/TopLayoutBlog';
import { docs } from './2026-MUI-X-price-changes.md?muiMarkdown';

export default function Page() {
  return <TopLayoutBlog docs={docs} />;
}
